/**
 *
 * Elastic For SIEM Integration
 *
 */

import React, { FC, useState } from 'react';

import { useSelector } from 'react-redux';

import { Form, FormAction } from 'components/index';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { DUMMY_API_KEY } from 'containers/Setup/Integrations/types';

interface Props {
  onSubmit(data);
  actionType?: FormAction;
}

export const ElasticForSIEMForm: FC<Props> = props => {
  const { onSubmit, actionType = 'Add' } = props;
  const { client, activeClient } = useSelector(selectIntegrations);
  const { onCancel } = useIntegrations();
  const [error, setError] = useState('');
  const { data: currentRecord } = activeClient;

  return (
    <Form
      schema={{
        name: {
          type: 'text',
          label: 'Connector Name',
          isRequired: true,
          isDisabled: actionType === 'Update',
          defaultValue: actionType === 'Update' ? currentRecord?.name : '',
          tooltip:
            'Only alphanumeric, hyphen, underscore and space is allowed!',
          onChange: value => {
            if (value.match(/^[a-zA-Z0-9-_ ]*$/i)) setError('');
            else
              setError(
                'Only alphanumeric, hyphen, underscore and space is allowed!',
              );
          },
          error: error,
          autoFocus: true,
        },
        description: {
          type: 'textArea',
          label: 'Description',
          defaultValue:
            actionType === 'Update' ? currentRecord?.description ?? '' : '',
        },
        url: {
          type: 'text',
          label: 'URL',
          isRequired: true,
          isDisabled: actionType === 'Update',
          defaultValue: currentRecord?.elastic_search?.url,
        },
        api_Key: {
          type: 'text',
          label: 'API Access Key',
          isRequired: true,
          htmlInputType: 'password',
          passwordShow: false,
          isDisabled: actionType === 'Update',
          defaultValue: actionType === 'Update' ? DUMMY_API_KEY : '',
        },
      }}
      buttonOptions={{
        submit: {
          name: actionType === 'Add' ? 'OK' : actionType?.toUpperCase(),
          isLoading: client.isLoading,
          isDisabled: client.isLoading,
        },
        reset: {
          name: 'CANCEL',
          isVisible: true,
          isDisabled: client.isLoading,
          onClick: onCancel,
        },
      }}
      handleSubmit={onSubmit}
    />
  );
};
